export default __webpack_public_path__ + "static/media/world-cup-vs-bg.ae57b060.jpg";